import { render, staticRenderFns } from "./SGPRowComponent.vue?vue&type=template&id=6643e306"
import script from "./SGPRowComponent.vue?vue&type=script&lang=js"
export * from "./SGPRowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports